export default __webpack_public_path__ + "static/media/roboto-latin-400italic.b1d9d990.woff";